<script>
    import { isLoading } from "../stores.js";
</script>

{#if $isLoading}
    <div class="container">
        <div class="loader" />
    </div>
{/if}

<style>
    .container {
        position: absolute;

        display: flex;
        align-items: center;
        justify-content: center;

        background: rgba(0, 0, 0, 0.7);
        z-index: 100000;

        height: 100%;
        width: 100%;

        top: 0px;
        left: 0px;
    }

    .loader {
        border: 10px solid #f3f3f3;
        border-top: 10px solid transparent; /* border-top: 10px solid #000; */
        border-radius: 50%;
        width: 100px;
        height: 100px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
